import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Tooltip } from "antd";
import { getStyleProperties, getUrlCode } from "../../../utils/CustomFunc";
import { LeftOutlined } from "@ant-design/icons";
import { NavLink, useHistory } from "react-router-dom";

const Header = (props) => {
  let history = useHistory();
  const [headerSetting, setHeaderSetting] = useState(null);
  useEffect(() => {
    if (props.settings && props.settingValues) {
      const titleStyle = getStyleProperties(props.settings.ld_PageTitle);

      const header = {
        company_logo: { logo: props.settings.ld_Logo_Comp.text },
        prod_logo: { logo: props.settings.ld_Logo_Prod.text },
        title: { title: props.settingValues.ld_PageTitle, style: titleStyle },
      };
      setHeaderSetting(header);
    }
  }, [props]);

  const getImgName = (src) => {
    if (src) {
      const strArray = (src + "").split("/");
      return strArray[strArray.length - 1];
    }
  };

  return (
    <React.Fragment>
      {headerSetting != null ? (
        <Row justify="space-around" align="middle" className="linedashzen-header" style={{ padding: 6 }}>
          {/* <Col flex="50px">
            <div
              style={{
                marginLeft: "20px",
                marginRight: "20px",
                padding: "5px",
                borderRadius: "50%",
                boxShadow:
                  "inset 5px 5px 9px #171717,inset -5px -5px 9px #232323",
              }}
            >
              <LeftOutlined
                style={{ fontSize: 30, cursor: "pointer" }}
                onClick={() => history.push("/dashboard")}
              />
            </div>
          </Col> */}
          <Col flex="150px" style={{ padding: "10px 10px", background: "#ffffff", borderRadius: 7, marginLeft: 10,display: 'flex', justifyContent: 'center', alignItems: 'center'  }}>
            <Tooltip
              title={getImgName(headerSetting.company_logo.logo)}
              placement="right"
            >
              <NavLink to={`/v02/${getUrlCode()}/dashboard`}>
                <img
                  className="spin"
                  src={headerSetting.company_logo.logo}
                  width="100%"
                  style={{ maxHeight: "50px" }}
                  alt="logo"
                ></img>
              </NavLink>
            </Tooltip>
          </Col>
          <Col
            flex="auto"
            style={{ padding: "10px 10px 10px 10px", textAlign: "center" }}
          >
            <span
              style={{
                ...headerSetting.title.style,
                padding: "5px",
                borderRadius: "5px",
                paddingRight: "10px",
                paddingLeft: "10px"
              }}
            >
              {headerSetting.title.title}
            </span>
          </Col>
          <Col flex="150px" style={{ padding: "10px 10px", background: "#ffffff", borderRadius: 7, marginRight: 10, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Tooltip
              title={getImgName(headerSetting.prod_logo.logo)}
              placement="left"
            >
              <NavLink to={`/v02/${getUrlCode()}/dashboard`}>
                <img
                  src={headerSetting.prod_logo.logo}
                  width="100px"
                  style={{ maxHeight: "50px" }}
                  alt="logo"
                ></img>
              </NavLink>
            </Tooltip>
          </Col>
        </Row>
      ) : null}
    </React.Fragment>
  );
};
export default Header;
